import clsx from 'clsx';
import React from 'react';

type TreatmentHeader = {
  title: string;
  children: React.ReactNode;
};

const TreatmentHeader = ({ title, children }: TreatmentHeader) => {
  return (
    <div
      className={clsx(
        'deleteDraft--container',
        'tw-flex tw-items-center tw-justify-between',
        'tw-min-w-[135px] tw-w-full',
        'tw-bg-cfo-grey-100',
        'tw-rounded-[5px]',
        'tw-py-[2px] tw-px-[10px]'
      )}
    >
      <p
        className={clsx(
          'tw-text-cfo-black tw-text-[18px] tw-font-brandonTextMedium',
          'tw-mr-[10px]'
        )}
      >
        {title}
      </p>
      {children}
    </div>
  );
};

export default TreatmentHeader;
